var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 82,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3026 44.1078L45.3134 47.6973C45.3279 52.4832 52.2141 54.5562 52.2141 54.5562C52.2141 54.5562 44.3055 60.5626 36.0797 60.5875C27.8539 60.6125 19.9091 54.6541 19.9091 54.6541C19.9091 54.6541 26.8366 52.5393 26.768 47.7535C26.6993 42.9677 26.727 40.1559 26.6659 31.9565C22.3621 26.4128 22.626 22.6825 24.9622 20.0527C32.7893 11.2422 54.1855 14.1686 54.1855 14.1686C54.1855 14.1686 56.2465 35.6971 51.7273 41.9945C49.7912 44.6925 45.3026 44.1078 45.3026 44.1078Z",
    fill: "url(#paint0_linear_3165_3009)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M45.3043 44.1078C38.7214 43.38 34.8242 40.5501 34.8242 40.5501C37.2903 44.1747 41.0395 46.7289 45.3152 47.6972L45.3043 44.1078Z",
    fill: "url(#paint1_linear_3165_3009)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4961 63.5757C70.3612 69.3571 72.0409 82.7058 72.0409 82.7058L0.252036 82.9234C0.252036 82.9234 1.85132 69.5634 4.6808 63.7661C7.51027 57.9689 24.1197 52.5496 24.1197 52.5496C27.3441 59.1185 44.9309 59.0651 47.9808 52.4752C47.9808 52.4752 64.6309 57.7943 67.4961 63.5757Z",
    fill: "url(#paint2_linear_3165_3009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9266 75.2481C34.9259 75.0114 34.9954 74.7799 35.1263 74.5827C35.2571 74.3856 35.4435 74.2317 35.6619 74.1404C35.8802 74.0492 36.1207 74.0248 36.353 74.0703C36.5852 74.1157 36.7987 74.229 36.9666 74.3958C37.1344 74.5627 37.249 74.7755 37.2959 75.0075C37.3428 75.2394 37.3198 75.4801 37.2299 75.699C37.14 75.9179 36.9872 76.1052 36.7909 76.2373C36.5945 76.3693 36.3634 76.4402 36.1267 76.4409C35.8094 76.4419 35.5047 76.3168 35.2796 76.0931C35.0546 75.8694 34.9276 75.5654 34.9266 75.2481ZM34.9085 69.2657C34.9078 69.029 34.9772 68.7975 35.1081 68.6003C35.239 68.4032 35.4254 68.2493 35.6437 68.158C35.8621 68.0668 36.1026 68.0424 36.3348 68.0879C36.5671 68.1333 36.7806 68.2466 36.9484 68.4134C37.1163 68.5803 37.2309 68.7931 37.2777 69.0251C37.3246 69.257 37.3017 69.4977 37.2118 69.7166C37.1219 69.9355 36.9691 70.1228 36.7727 70.2549C36.5764 70.3869 36.3452 70.4578 36.1086 70.4585C35.7913 70.4595 35.4866 70.3344 35.2615 70.1107C35.0364 69.887 34.9094 69.583 34.9085 69.2657ZM34.8903 63.2833C34.8896 63.0466 34.9591 62.8151 35.09 62.6179C35.2208 62.4208 35.4072 62.2669 35.6256 62.1756C35.844 62.0844 36.0845 62.06 36.3167 62.1054C36.5489 62.1509 36.7625 62.2642 36.9303 62.431C37.0981 62.5979 37.2127 62.8107 37.2596 63.0427C37.3065 63.2746 37.2835 63.5153 37.1936 63.7342C37.1037 63.9531 36.9509 64.1404 36.7546 64.2725C36.5582 64.4045 36.3271 64.4754 36.0905 64.4761C35.7731 64.4771 35.4684 64.352 35.2434 64.1283C35.0183 63.9045 34.8913 63.6006 34.8903 63.2833V63.2833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3261 22.978C29.3724 22.164 28.215 21.6174 26.5838 22.4713C22.7165 24.494 25.6713 32.2024 29.1112 32.192C30.0086 32.1893 30.4634 35.0062 26.474 36.9859C26.4645 33.8452 21.655 26.0826 21.2148 19.0031C16.3935 17.2244 17.5682 10.0458 20.8744 10.0358C20.3268 3.46033 30.8488 0.0309882 34.9385 3.79322C39.071 -1.19043 49.5479 1.32035 50.193 5.63114C57.3803 1.76652 62.1459 12.7984 55.4182 17.107C52.6498 18.8802 46.1633 19.5714 36.797 19.5998C35.383 19.6041 34.592 19.9577 34.9928 21.7048C35.7685 25.0904 33.9979 27.2297 30.3261 22.978Z",
    fill: "url(#paint3_linear_3165_3009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3165_3009",
    x1: 37.2031,
    y1: 13.7293,
    x2: 37.3451,
    y2: 60.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3165_3009",
    x1: 43.3188,
    y1: 41.874,
    x2: 41.5063,
    y2: 48.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3165_3009",
    x1: 36.0546,
    y1: 52.5113,
    x2: 36.1465,
    y2: 82.8146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3165_3009",
    x1: 38.2847,
    y1: 1.05461,
    x2: 38.3935,
    y2: 36.9498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfile);
export default __webpack_public_path__ + "static/media/StudentProfile.ef9628d5c6082faf8addc1f578779cf6.svg";
export { ForwardRef as ReactComponent };